<template>
  <div class="flight-item clearfix">
    <div class="flight-info clearfix">
      <div :class="['airline-logo', 'logo', `logo-${passengerData.airlineCode.toLocaleLowerCase()}`]"></div>
      <div class="flight-time clearfix">
        <div class="dep-info">
          <p>{{passengerData.depTime | timeFormat}}</p>
          <p class="city">{{passengerData.departureAirportName}}</p>
        </div>
        <div class="route">
          <p>{{passengerData.flightNumber}}</p>
          <div class="line"></div>
          <p>{{passengerData.flightDate | dateFormat}}</p>
        </div>
        <div class="dest-info">
          <p>{{passengerData.arrTime | timeFormat}}</p>
          <span class="gt-day">{{ passengerData | getDaySpan('depTime', 'arrTime') }}</span>
          <p class="city">{{passengerData.arrivalAirportName}}</p>
        </div>
      </div>
      <div class="cabin">
        <p>{{passengerData.seatNumber}}</p>
        <p>
          <span>座位号</span>
        </p>
      </div>
      <div class="status">
        <p>{{passengerData.boardingGateNumber}}</p>
        <p>
          <span>登机口</span>
        </p>
      </div>
    </div>
    <div class="passneger-info">
      <p class="name">{{ passengerData.chnName }}</p>
      <p>凭证类型：{{ passengerData.certificateType | certTypeFormat }}</p>
      <p>凭证号：{{ codeMask(passengerData.certificateNumber, {offset: 4, length: 10}) }}</p>
    </div>
  </div>
</template>
<script>
import moment from 'moment'
import { getDaySpan } from '@/filters/time'
import codeMask from '@/assets/js/codeMask'

export default {
  props: {
    passengerData: { type: Object },
    flightStatus: { type: String }
  },
  data () {
    return {
      codeMask
    }
  },
  filters: {
    getDaySpan,
    dateFormat (value) {
      return moment(value).format('YYYY-MM-DD')
    },
    timeFormat (value) {
      return moment(value).format('HH:mm')
    },
    certTypeFormat (value) {
      const certTypeMap = {
        'NI': '身份证',
        'PP': '护照',
        'TN': '电子客票'
      }
      return certTypeMap[value]
    }
  }
}
</script>

<style lang="less" scoped>
.flight-item {
  padding: 10px 0;
  border: 1px solid #bfbfbf;
  .flight-info {
    float: left;
    width: 938px;
    padding: 20px 10px;
    border-right: 1px dashed #d0d0d0;
    .checkbox {
      float: left;
      width: 45px;
      padding-top: 15px;
      text-align: center;
      color: #808080;
      font-size: 12px;
      line-height: 24px;
    }
    .logo {
      float: left;
      width: 48px;
      height: 59px;
      margin: 0 30px;
      margin-top: 5px;
    }
    .flight-time {
      float: left;
      width: 460px;
    }
    .dep-info,
    .dest-info {
      float: left;
      width: 150px;
      margin-top: 5px;
      text-align: center;
      font-weight: bold;
      position: relative;
      .gt-day {
        position: absolute;
        top: 0;
        right: -5px;
        font-size: 12px;
        color: @primary-color;
      }
      p {
        font-size: 24px;
        line-height: 32px;
        color: #000;
      }
      p.city {
        font-weight: normal;
        font-size: 14px;
      }
    }
    .route {
      float: left;
      width: 120px;
      margin: 0 15px;
      font-size: 12px;
      line-height: 36px;
      text-align: center;
      color: #808080;
      .line {
        border-bottom: 1px solid #d0d0d0;
      }
    }
    .cabin,
    .status {
      float: left;
      width: 80px;
      margin: 0 20px;
      margin-top: 10px;
      text-align: center;
      font-size: 18px;
      line-height: 26px;
      color: #000;
      font-weight: bold;
      span {
        font-weight: normal;
        font-size: 12px;
        color: #808080;
      }
    }
    .cabin {
      margin-left: 60px;
    }
  }
  .passneger-info {
    float: left;
    width: 340px;
    padding: 15px 10px 15px 78px;
    text-align: left;
    p {
      font-size: 14px;
      line-height: 24px;
      color: #808080;
    }
    p.name {
      font-size: 18px;
      color: #000;
      margin-bottom: 15px;
      font-weight: bold;
    }
  }
}
@media only screen and (max-width: 768px) {
  .flight-item {
    border: 0;
    width: 550px;
    .logo {
      display: none;
    }
    .flight-info {
      width: 550px;
      padding: 10px 5px;
      border-right: 0;
      .flight-time {
        width: 300px;
      }
      .route {
        width: 100px;
        margin: 0 10px;
      }
      .cabin {
        margin-left: 20px;
        margin-right: 30px;
      }
      .status {
        margin-left: 20px;
        margin-right: 0;
      }
    }
    .passneger-info {
      width: 550px;
      padding-top: 0;
      padding-left: 15px;
      p.name {
        display: block;
      }
      p {
        display: inline-block;
        margin-right: 20px;
      }
    }
  }
}
</style>
